const HEADER_MOD = {
  'Is AI built into your applications to automate and simplify the sales process?': {
    header: 'AI and Automation',
    negCopy:
      'Monitor sales engagement levels and touchpoints across all accounts using AI, and track activities related to leads, opportunities.',
    negLink: '',
    negLinkTxt: '',
  },
  'Does your CRM use digital tools, such as intelligent recommendations, to guide the sales experience?': {
    header: 'Guided Selling',
    negCopy: 'Guide sellers through the sales process with intelligent recommendations.',
    negLink: '',
    negLinkTxt: '',
  },
  'Does your CRM improve seller productivity by providing relevant and reliable customer data whenever sellers need it?':
    {
      header: 'Seller Productivity',
      negCopy:
        'Improve productivity and satisfaction with intuitive tools that make it easier for sellers to find the data they need to drive business results.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do you offer a mobile application that gives sellers the ability to access their CRM from anywhere?': {
    header: 'Mobile Application',
    negCopy:
      'Access and work with CRM data anywhere. Mobile applications are designed to help sellers get things done faster.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are you able to collect and connect data from multiple systems and applications to get a holistic view of your customers?':
    {
      header: 'Data and Integration',
      negCopy:
        'Create a unified view of the customer by connecting online and offline data sources across sales, marketing, service, finance, HR, and supply chain.',
      negLink: '',
      negLinkTxt: '',
    },
  'Are your marketing and sales applications integrated to deliver a seamless customer experience?': {
    header: 'Marketing Alignment',
    negCopy:
      'Tight integration between sales and marketing provides the context sellers need to act quickly on qualified leads. ',
    negLink: '',
    negLinkTxt: '',
  },
  'Are your applications integrated across all customer touchpoints to give you a full view of their buying journey?': {
    header: 'Connected Applications',
    negCopy:
      'Connect sales, finance, and HR operations together to deliver real-time intelligence, allowing you to focus on building high-performance sales teams that win more deals.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your tools provide predictive intelligence to help you plan and project sales success?': {
    header: 'Predictive Planning',
    negCopy: 'Predictive planning ensures the accuracy of sales plans through embedded predictive analytics.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do you have the right data and tools to set realistic quotas for sellers and then assign well-balanced territories to reach sellers’ goals?':
    {
      header: 'Quota & Territory Management',
      negCopy:
        'Easily create and adjust quotas and territories based on past seller success, new business initiatives, industry shifts, and current progress.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can you motivate sellers with interactive engagement tools, such as gamification and contests?': {
    header: 'Gamification',
    negCopy:
      'Keep sellers motivated through gamification with the right balance of monetary and non-monetary incentives.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your applications allow you to build clear and fair incentive plans that motivate and satisfy your sales teams?':
    {
      header: 'Incentive Compensation',
      negCopy: 'Improve seller satisfaction and performance with clear and fair incentives.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do your applications offer real-time individual and team performance reports to keep leadership informed and sellers motivated?':
    {
      header: 'Intelligent Reporting',
      negCopy:
        'Provide leadership visibility into sales teams’ KPIs with performance scorecards and intelligent reports that keep sellers motivated to hit their goals.',
      negLink: '',
      negLinkTxt: '',
    },
  'Are your applications connected across all customer touchpoints to give you a full view of your customers’ journeys?':
    {
      header: 'Connected Applications  ',
      negCopy:
        'Create a unified view of the customer by connecting online and offline data sources across all your CRM, ERP, and other data sources.',
      negLink: '',
      negLinkTxt: '',
    },
  'Is AI built into your applications to automate and simplify the sales process?': {
    header: 'AI and Automation',
    negCopy:
      'Monitor sales engagement levels and touchpoints across all accounts using AI, and track activities related to leads, opportunities.',
    negLink: '',
    negLinkTxt: '',
  },
  'Does your CRM use digital tools, such as intelligent recommendations, to guide the sales experience?': {
    header: 'Guided Selling',
    negCopy: 'Guide sellers through the sales process with intuitive tools and intelligent recommendations.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your sellers have the customer data needed to engage digital buyers?': {
    header: 'Customer Intelligence',
    negCopy: 'Make every customer interaction matter with customer intelligence you can trust.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can customers access account information and purchase products and services on any digital channel, with or without speaking to a rep?':
    {
      header: 'Digital Self-Service ',
      negCopy:
        'Deliver complete self-service experiences on any channel to meet the needs and expectations of the increasingly self-sufficient buyer.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can customers purchase your goods and services on any digital channel, with or without speaking to a rep?': {
    header: 'Digital Self-Service',
    negCopy:
      'Deliver a personalized purchasing experience with self-service capabilities while meeting the complexities inherent of B2B sales.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you create, manage, and publish personalized content across any digital channel?': {
    header: 'Content Management',
    negCopy: 'Create content that delivers personalized experiences that go beyond the site, page, or email.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do you offer a solution that allows you to deliver an end-to-end sales-to-order process, configuring quotes based on buyers’ unique needs?':
    {
      header: 'Configure to Close',
      negCopy:
        'Sell goods and services through any channel, with sophisticated configuration, bundling, and asset-based ordering tools',
      negLink: '',
      negLinkTxt: '',
    },
  'Can you support recurring revenue models?': {
    header: 'Subscription Management',
    negCopy: 'Support recurring revenue and relationships through subscription pricing models.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you deliver personalized and relevant experiences to buyers on all digital channels?': {
    header: 'Personalization',
    negCopy:
      'Sellers can easily engage buyers on any channel at any time through email, video chat, or on the phone with digital tools built directly into their CRM.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can your business teams reuse web components and widgets to easily build, launch, and manage sites without the need for IT support?':
    {
      header: 'Web Development',
      negCopy:
        'Enable your entire team, not just IT experts, to build, launch and manage sites quickly and easily with reusable components.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your CX applications predict customers’ actions and provide recommendations?': {
    header: 'Predictive Intelligence',
    negCopy:
      'Combine customer data and AI to interpret buyer signals and deliver the right products at the right time.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are your marketing and commerce platforms fully integrated to provide frictionless campaign to conversion experiences?':
    {
      header: 'Marketing',
      negCopy: 'Creating a smooth streamlined experience from campaign to purchase increases conversion rates.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do you offer a solution that allows you to deliver an end-to-end sales-to-order process, configuring quotes based on buyers’ unique needs?':
    {
      header: 'Configure, price, and quote',
      negCopy:
        'Sell goods and services through any channel, with sophisticated configuration, bundling, and asset-based ordering tools.',
      negLink: '',
      negLinkTxt: '',
    },
  'Does your solution offer a complete Quote to Cash process, allowing you to meet your buyers’ unique needs?': {
    header: 'Configure, price, and quote ',
    negCopy:
      'Simplify complex configuration, bundling, and asset-based ordering with the help of Oracle Configure, Price, and Quote.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you support subscription purchasing and provide customers access to manage their accounts and services on their own?':
    {
      header: 'Subscription Management ',
      negCopy:
        'Enable subscription management and flexible purchasing options across your business and self-service channels.',
      negLink: '',
      negLinkTxt: '',
    },
  'Are your applications connected across all customer touchpoints to give you a full view of your customers’ journey?':
    {
      header: 'Connected Applications ',
      negCopy:
        'Create a unified view of the customer by connecting online and offline data sources across all your CRM, ERP, and other data sources.',
      negLink: '',
      negLinkTxt: '',
    },
  ' Are your applications integrated across all customer touchpoints to give you a full view of your customers’ journeys?':
    {
      header: 'Connected Applications  ',
      negCopy:
        'Create a unified view of the customer by connecting online and offline data sources across all your CRM, ERP, and other data sources.',
      negLink: '',
      negLinkTxt: '',
    },
  ' Are your applications integrated across all customer touchpoints to give you a full view of your customers’ journeys? ':
    {
      header: 'Connected Applications   ',
      negCopy:
        'Create a unified view of the customer by connecting online and offline data sources across all your CRM, ERP, and other data sources.',
      negLink: '',
      negLinkTxt: '',
    },
  'Are your applications integrated across all customer touchpoints to give you a full view of your customers’ journeys? ':
    {
      header: 'Connected Applications  ',
      negCopy:
        'Create a unified view of the customer by connecting online and offline data sources across all your CRM, ERP, and other data sources.',
      negLink: '',
      negLinkTxt: '',
    },
  'Is your customer data connected across CX, finance, operations applications to better understand and serve your customers’ needs?':
    {
      header: 'Connected Customer Data',
      negCopy:
        'Create a unified view of your customer by connecting online and offline data across all your CRM, ERP, and other data sources.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do you have visibility into deal metrics to drive reliable data and offer management?': {
    header: 'Data Management',
    negCopy: 'Gain visibility into deal metrics to ensure you focus on the right opportunities.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you automatically route contracts for review, signature, and approval?': {
    header: 'Automated Approvals',
    negCopy:
      'Automate and route contracts for approvals and signatures, store contracts with accounts or opportunities, and analyze trends.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you sell complex products while supporting the broad spectrum of order-to-revenue processes?': {
    header: 'Complex Revenue Management',
    negCopy: 'Automate billing and payment processing and recognize ongoing revenue in your existing ERP solution.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can your organization easily and efficiently generate proposals?': {
    header: 'Proposal Generator',
    negCopy: 'Deliver highly professional and accurate output documents at the quote, proposal, and contract phase.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you easily deploy standardized pricing and discounts across all sales channels?': {
    header: 'Channel Enablement',
    negCopy:
      'Sellers can easily engage buyers on any channel at any time through email, video chat, or on the phone with digital tools built directly into their CRM.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you expand offerings and grow revenue through subscription services?': {
    header: 'Subscription Management  ',
    negCopy:
      'Expand your product and service offerings, improve customer retention, and grow predictable revenues with subscription services.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can your customers manage and change their subscriptions without speaking to a sales rep?': {
    header: 'Self-Service',
    negCopy: 'Enable customers to create, monitor, and modify their subscriptions on self-service channels.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are you able to support and automate the order-to-revenue process?': {
    header: 'Order-to-revenue management',
    negCopy: 'Automate revenue recognition in your core ERP systems for subscription use cases.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are you able to up-sell and cross-sell products based on customer purchase history and needs?': {
    header: 'Up-sell and Cross-sell',
    negCopy:
      'Determine relevant cross-sell and up-sell opportunities based on your customer’s needs and purchase history.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do you have deep insight into relevant customer subscription metrics?': {
    header: 'Customer Insights',
    negCopy: 'Understand how subscriptions are impacting the business and gain a complete view of your customers.',
    negLink: '',
    negLinkTxt: '',
  },
};
export default HEADER_MOD;
